import { OrthoFlight, Project } from "@nova/protobuf"
import {
    booleanValidator,
    boundingBoxValidators,
    colorValidators,
    demoIdValidators,
    genericCreateLayerValidator,
    UnionToTuple,
    updateLayerValidator,
} from "../util"
import { dateAsNumber, encodeColorToNumber } from "../../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import {
    Integration,
    scanAreaDefaultHexFillColor,
    scanAreaDefaultHexOutlineColor,
} from "@nova/constants"

export const createOrthoFlightValidator = genericCreateLayerValidator

export const updateOrthoFlightValidator = updateLayerValidator(OrthoFlight, {
    orthoBoundingBox: { validators: boundingBoxValidators, nonNull: true },
    integrations: {
        validators: [
            {
                validator: (string) => {
                    try {
                        const json = JSON.parse(string)
                        let valid = true
                        ;(Object.values(json) as Integration[]).forEach(
                            (integration: Integration) => {
                                if (
                                    integration.updatedAt < 0 ||
                                    integration.updatedBy.userId.length !== 36
                                )
                                    valid = false
                            }
                        )

                        return valid
                    } catch {
                        return false
                    }
                },
                error: "updatedAt must be >= 0 and userId must be valid",
            },
        ],
    },
    scanAreaFillColor: { validators: colorValidators },
    scanAreaOutlineColor: { validators: colorValidators },
    processAfterUpload: {
        validators: booleanValidator("processAfterUpload must be a boolean value"),
    },
    demoId: {
        validators: demoIdValidators,
    },
})

export const getDefaultOrthoFlightCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    images: [],
    orthoBoundingBox: [],
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    processAfterUpload: true,

    // parentId would never got autopopulated
    parentId: undefined,
    scanAreaFillColor: encodeColorToNumber(scanAreaDefaultHexFillColor),
    scanAreaOutlineColor: encodeColorToNumber(scanAreaDefaultHexOutlineColor),
})

export type CreateOrthoFlightArgs = UnionToTuple<keyof typeof createOrthoFlightValidator>
export type UpdateOrthoFlightArgs = UnionToTuple<keyof typeof updateOrthoFlightValidator>
